module.exports = __webpack_public_path__ + "static/made-to-stick-07a2858ddb17914e02c9aa9a714c5a3d.jpg";